import { useState, useEffect } from 'react';

/**
 * Self-updating elapsed-time display.
 * Owns its own setInterval so parent cards don't re-render every tick.
 */
function ElapsedTimer({ createdAt, className, render }) {
  const calc = () => Math.floor((Date.now() - new Date(createdAt).getTime()) / 60000);
  const [minutes, setMinutes] = useState(calc);

  useEffect(() => {
    const id = setInterval(() => setMinutes(calc()), 60000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdAt]);

  if (render) return render(minutes);
  if (minutes <= 0) return null;
  return <span className={className}>{minutes}min</span>;
}

export default ElapsedTimer;
